export const desktopWidth = '1200px'
export const tabletWidth = '1000px'
export const mobileWidth = '800px'
export const darkGray = '#262626'
export const gray = '#5b5e5e'
export const lightGray = '#eeeeee'
export const red = '#e85555'
export const brand1 = '#1ba54a'
export const brand2 = '#00d9ff'
export const brand3 = '#C3FCF2'